/**
 * The "Try a sample: refund-policy.md" import file — byte-identical to the
 * prototype's `wkSampleMd()` (829,901). Shipped as a static asset so real
 * users get the same affordance (C2-modals-import §1.9). 705 bytes; imports
 * as "Refund policy", 12 blocks · 1 paragraph · 3 headings · 1 table ·
 * 3 steps · 1 callout · 3 to-dos.
 */
export const REFUND_POLICY_SAMPLE_NAME = 'refund-policy.md';

export const REFUND_POLICY_SAMPLE_MD = [
    '# Refund policy',
    '',
    'Customers can ask for a refund within **30 days** of their first invoice.',
    '',
    '## Who can approve a refund',
    '',
    '| Amount | Who approves | Where |',
    '| --- | --- | --- |',
    '| Up to $500 | CS lead | In the CRM ticket |',
    '| $500 to $5,000 | Head of CS | Refund form |',
    '| Above $5,000 | CFO | Refund form and finance review |',
    '',
    '## How to process a refund',
    '',
    '1. Check the invoice date in the CRM.',
    '2. Confirm the amount with the customer.',
    '3. Submit the [refund form](https://forms.goteam.example/refund).',
    '',
    '> [!WARNING]',
    '> Never promise a refund on a call before it is approved.',
    '',
    '## Checklist before you close the ticket',
    '',
    '- [ ] Refund approved',
    '- [ ] Customer told the date it lands',
    '- [x] Ticket linked to the invoice',
].join('\n');
